import { Box, Button, styled, TableCell } from '@mui/material';

import { FlexBox } from '@/shared/ui/layout';

export const TypeButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  minWidth: 115,
  maxWidth: 240,
  padding: theme.spacing(1, 2.5),
  borderRadius: theme.spacing(9.5),
  gap: theme.spacing(3),
  textTransform: 'none',
  backgroundColor: theme.customColors.black20,
  '&:hover': {
    backgroundColor: theme.customColors.primary10,
    borderColor: theme.customColors.primary10,
  },
  '& .MuiTypography-root': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export const ModalBodyContainer = styled(FlexBox)(({ theme }) => ({
  width: '100%',
  minWidth: 0,
  gap: theme.spacing(5),
  flexDirection: 'column',
  borderRadius: theme.spacing(3),
}));

export const StatusBadge = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 3.5),
  borderRadius: 40,
  backgroundColor: theme.customColors.failure50,
  color: theme.customColors.red90,
}));

export const CustomTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(2.5, 1),
}));
